import {StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  modal: {
    margin: 0,
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  },
  container: {
    backgroundColor: white,
    width: '33.33%',
    height: '100%',
    paddingBottom: 12,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10,
    marginTop: 10,
  },
  closeIcon: {
    fontSize: 24,
  },
  headerTitle: {
    fontSize: 16,
    marginLeft: 8,
  },
  content: {
    flexDirection: 'column',
    marginHorizontal: 20,
  },
});
